import { render } from "./ShowEmailTemplates.vue?vue&type=template&id=33e0e85e"
import script from "./ShowEmailTemplates.vue?vue&type=script&lang=js"
export * from "./ShowEmailTemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__